import { lazy } from "react";
import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import LoginRoutes from "./LoginRoutes";
import Loadable from "ui-component/Loadable";

// Login Page
const FirstLoadLogin = Loadable(lazy(() => import("views/pages/authentication/authentication3/Login3")));

// Error Page
const Error = Loadable(lazy(() => import("views/pages/maintenance/Error")));
const Unauthorized = Loadable(lazy(() => import("views/pages/maintenance/Unauthorized")));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    { path: "/", element: <FirstLoadLogin /> },
    { path: "*", element: <Error /> },
    { path: "/unauthorized", element: <Unauthorized /> },
    LoginRoutes,
    MainRoutes,
  ]);
}
